import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import { AppContext } from '../../../../../RoutesWithAuth';
import axios from '../../../../common/AxiosConfig';

const useStyles = makeStyles(() => ({
    notesButton: {
        height: '27px',
        width: '80px',
        marginTop: '18px',
        backgroundColor: '#3924FC'
    },
    notesForm: {
        marginTop: '15px',
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: '20px'
    },
    notesInput: {
        width: '500px',
        maxWidth: '100%',
        height: '60px',
        boxSizing: 'border-box',
        padding: '8px',
        border: '1px solid #C4D2E2',
        marginBottom: '35px',
        borderRadius: '8px',
        font: 'inherit',
        overflowY: 'auto',
        resize: 'none'
    },
    sidebarDivider: {
        borderTop: '1px solid #e7e6e6',
        width: '82vw',
        marginLeft: '-34px',
        padding: '8px 0px 20px 0px',
    },
}));

export default function Notes({ taskId, onSubmit }) {
    const classes = useStyles();
    const context = useContext(AppContext);
    const authToken = context.authToken.get;
    const [notes, setNotes] = useState('');
    const [savedNotes, setSavedNotes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [refreshVersion, setRefreshVersion] = useState(0);

    useEffect(() => {
        let isActive = true;
        setSavedNotes([]);
        setError('');
        setIsLoading(false);
        if (!taskId) return;

        setIsLoading(true);
        axios.get(`centra/privacy-task/${encodeURIComponent(taskId)}/notes`, {
            headers: { Authorization: authToken }
        }).then((response) => {
            if (isActive) setSavedNotes(response.data?.notes || []);
        }).catch((err) => {
            if (isActive) {
                setError(err?.response?.data?.message || err?.message || 'Unable to load notes.');
            }
        }).finally(() => {
            if (isActive) setIsLoading(false);
        });

        return () => {
            isActive = false;
        };
    }, [taskId, authToken, refreshVersion]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const note = notes.trim();
        if (!note || !taskId || isSubmitting) return;

        setIsSubmitting(true);
        setError('');
        try {
            await axios.post(`centra/privacy-task/${encodeURIComponent(taskId)}/notes`, {
                note
            }, {
                headers: { Authorization: authToken }
            });
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Unable to save note.');
            return;
        } finally {
            setIsSubmitting(false);
        }

        setNotes('');
        setRefreshVersion((version) => version + 1);
        if (onSubmit) onSubmit(note);
    };

    return (
        <div>
            <div>
                <div>
                    <div>
                        <h6>Notes / Comments</h6>
                    </div>
                    <form className={classes.notesForm} onSubmit={handleSubmit}>
                        <textarea
                            className={classes.notesInput}
                            aria-label="Notes / Comments"
                            value={notes}
                            onChange={(event) => setNotes(event.target.value)}
                            placeholder="Enter Details..."
                            disabled={isSubmitting}
                        />
                        <Button className={classes.notesButton} type="submit" variant="contained" size="small" disabled={!notes.trim() || !taskId || isSubmitting}>
                            Submit
                        </Button>
                    </form>
                </div>
                <div>
                    {/* {isLoading && <p role="status">Loading notes...</p>} */}
                    {error && <p role="alert">{error}</p>}
                    {!isLoading && !error && savedNotes.length === 0 && <p>No notes found.</p>}
                    {savedNotes.map((savedNote) => (
                        <div>
                            <div className={classes.sidebarDivider}></div>
                            <div style={{ fontWeight: 'bold' }} key={savedNote.id}>
                                <p style={{ color: 'gray' }}>Date: {moment.parseZone(savedNote.created_at).format('MM/DD/YYYY hh:mma')} Updated By: {savedNote.created_by}</p>
                                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>Notes: {savedNote.note}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}